import React, { useState, useEffect } from 'react';

/**
 * muestra una lista de registros en forma de tabla
 * @param {List} heads Lista de encabezados de la tabla
 * @param {List} keys Lista de llaves de los datos a mostrar
 * @param {List} data Lista de datos a mostrar
 * @param {function} editFunction Función que se ejecuta al dar click en una fila de la tabla 
 * @param {boolean} tableBordered Bandera para mostrar la tabla con bordes
 * @param {boolean} stickyFirts Bandera para que la primera columna sea fija
 * @returns 
 */
const TablaCatalogos = (p) => {
    const heads = p.heads ?? [];
    const keys = p.keys ?? [];
    const data = p.data ?? [];
    const editFunction = p.editFunction ?? (() => { });
    const tableBordered = p.tableBordered ? "table-bordered" : "";
    const stickyFirts = p.stickyFirts ? { position: "sticky", left: 0, zIndex: 2, textAlign: "left", fontWeight: "bold" } : { textAlign: "center" };
    useEffect(() => {

    }, []);

    return (
        <table className={`table table-sm table-hover text-s ${tableBordered}`}>
            <thead>
                <tr>
                    {heads.map((k, i) => <th key={i} scope='col' className='text-center text-m' style={i === 0 ? stickyFirts : { textAlign: "center" }}>{k}</th>)}

                </tr>
            </thead>
            <tbody>
                {data.map((d, i) =>
                    <tr key={i + "erfd"} className='pointer nowrap' onClick={() => editFunction(d)}>
                        {keys.map((k, j) =>
                            <td key={j + "ddd" + i} className='nowrap' style={j === 0 ? stickyFirts : { textAlign: "center" }}>
                                {d[k] ?? 'N/A'}
                            </td>)
                        }
                    </tr>
                )}
            </tbody>
        </table>
    )
}

export default TablaCatalogos;